<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar">
  <!-- BEGIN scrollbar -->
  <div class="app-sidebar-content" data-scrollbar="true" data-height="100%">
    <!-- BEGIN mobile-toggler -->
    <div class="mobile-toggler">
      <button type="button" (click)="app.menuOpen = !app.menuOpen" class="menu-close btn btn-outline-primary"
        data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
        <i class="bi bi-arrow-left"></i>
      </button>
    </div>
    <!-- END mobile-toggler -->

    <!-- BEGIN Planned Burns menu -->
    <div class="menu margin">
      <div class="menu-item">
        <div [routerLink]="'/home'" class="p-3 d-flex align-items-center" (click)="app.menuOpen = !app.menuOpen">
          <a class="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill mr-2"><i class="fa fa-arrow-left me-1 ms-n1"></i> Back</a>
          <button *ngIf="selectedBurn" class="btn btn-outline-default text-nowrap btn-sm px-3 ml-2 rounded-pill" (click)="deselectBurn()">
            <i class="bi bi-arrow-left me-1"></i> Back to Summary
          </button>
        </div>
      </div>

      <!-- BEGIN Burn List Region Buttons -->
      <div class="menu-item">
        <div class="p-3">
          <div class="small text-muted mb-2 fw-bold">DASHBOARDS</div>
        </div>
      </div>

      <div *ngFor="let region of burnListRegions" class="menu-item bg-emphasis bg-opacity-25">
        <div class="p-3">
          <div class="small fw-bold mb-2 d-flex align-items-center justify-content-between" 
               style="cursor: pointer; user-select: none;"
               (click)="toggleDashboardRegion(region.id)">
            <div class="d-flex align-items-center">
              <i class="bi me-2" 
                 [ngClass]="isDashboardRegionOpen(region.id) ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"></i>
              <i class="bi bi-geo-alt me-2"></i>
              {{ region.name }}
            </div>
          </div>
          <div *ngIf="isDashboardRegionOpen(region.id)" class="d-grid gap-2">
            <button *ngFor="let type of burnListTypes"
                    type="button"
                    class="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-between"
                    [routerLink]="'/fire-foresight/burn-list-overview/' + region.id + '/' + type.id"
                    [title]="region.name + ' - ' + type.name"
                    (click)="app.menuOpen = false">
              <span>
                {{ type.name }}
              </span>
              <i class="bi bi-arrow-right-short"></i>
            </button>
            <button type="button"
                    class="btn btn-outline-success btn-sm d-flex align-items-center justify-content-between"
                    [routerLink]="'/fire-foresight/burn-coups/' + region.id"
                    [title]="region.name + ' - Burn Coups'"
                    (click)="app.menuOpen = false">
              <span>
                <i class="bi bi-fire me-2"></i>
                Burn Coups
              </span>
              <i class="bi bi-arrow-right-short"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="burnListRegions.length === 0" class="menu-item bg-emphasis bg-opacity-25">
        <div class="p-3 text-center text-muted small">
          No regions available
        </div>
      </div>
      <!-- END Burn List Region Buttons -->

      <div>
        <div class="menu-header">Burn Lists
          <i *ngIf="!loading" style="cursor: pointer;" (click)="loadPlannedBurns()" class="fa fa-refresh"></i>
          <div class="spinner-border spinner-border-sm text-primary" role="status" *ngIf="loading"><span class="visually-hidden">Loading...</span></div>
        </div>

      <div class="menu-item bg-emphasis bg-opacity-25">
          <div class="list-group mb-3">
            <button class="btn btn-primary btn-sm" (click)="openCreateBurnModal()">
              <i class="bi bi-plus-circle me-1"></i> New Burn List
            </button>
          </div>
        </div>

        <div class="menu-item bg-emphasis bg-opacity-25">
          <div class="list-group mb-3">
            <!-- Loop through region groups -->
            <ng-container *ngFor="let regionGroup of getGroupedBurnsByRegionAndType()">
              
              <!-- Region header (accordion trigger) -->
              <div class="list-group-item bg-dark bg-opacity-20 py-2" 
                   style="cursor: pointer; user-select: none;"
                   (click)="toggleRegion(regionGroup.region?.id || null)">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="fw-bold text-uppercase">
                    <i class="bi me-2" 
                       [ngClass]="isRegionOpen(regionGroup.region?.id || null) ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"></i>
                    {{ regionGroup.region?.name || 'No Region' }}
                  </div>
                  <span class="badge bg-secondary">
                    {{ getTotalBurnsInRegion(regionGroup.typeGroups) }}
                  </span>
                </div>
              </div>

              <!-- Region content (collapsible) -->
              <div *ngIf="isRegionOpen(regionGroup.region?.id || null)">
                
                <!-- Loop through type groups within this region -->
                <ng-container *ngFor="let typeGroup of regionGroup.typeGroups">
                  
                  <!-- Type header (accordion trigger) -->
                  <div class="list-group-item bg-dark bg-opacity-10 py-2 ps-4" 
                       style="cursor: pointer; user-select: none;"
                       (click)="toggleType(regionGroup.region?.id || null, typeGroup.type?.id || null)">
                    <div class="d-flex align-items-center justify-content-between">
                      <small class="fw-bold text-uppercase">
                        <i class="bi me-2" 
                           [ngClass]="isTypeOpen(regionGroup.region?.id || null, typeGroup.type?.id || null) ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"></i>
                        {{ typeGroup.type?.name || 'No Type' }}
                      </small>
                      <span class="badge bg-secondary">{{ typeGroup.burns.length }}</span>
                    </div>
                  </div>

                  <!-- Burn list items within this type (collapsible) -->
                  <div *ngIf="isTypeOpen(regionGroup.region?.id || null, typeGroup.type?.id || null)">
                    <div *ngFor="let burn of typeGroup.burns" 
                         class="list-group-item d-flex align-items-center bg-opacity-25 ps-5"
                         [ngClass]="{'bg-white':selectedBurnId == burn.id}" 
                         style="cursor:pointer;" 
                         (click)="selectBurn(burn)">
                      <div class="w-40px h-40px d-flex align-items-center justify-content-center text-white rounded-2 ms-n1"
                           [ngClass]="getStatusIconColorClass(burn.burnListStatusId)">
                        <i class="bi bi-calendar-check"></i>
                      </div>
                      <div class="flex-fill px-3">
                        <div class="fw-bold">
                          <span class="small text-inverse text-opacity-50"></span> {{burn.planName || 'Burn Plan #' + burn.id}}
                        </div>
                        <div class="flex-fill">
                          <div class="small text-inverse text-opacity-50">{{burn.expectedStartTime | date:'short'}}</div>
                          <div class="small text-inverse text-opacity-50" *ngIf="burn.expectedEndTime">End: {{burn.expectedEndTime | date:'short'}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </div>

            </ng-container>

            <div *ngIf="plannedBurns.length === 0" class="list-group-item d-flex align-items-center bg-opacity-50 text-opacity-50">
              No Planned Burns
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Planned Burns menu -->
  </div>
  <!-- END scrollbar -->
</div>
<!-- END #sidebar -->

<!-- BEGIN mobile-sidebar-backdrop -->
<button class="app-sidebar-mobile-backdrop" data-toggle-target=".app"
  data-toggle-class="app-sidebar-mobile-toggled"></button>
<!-- END mobile-sidebar-backdrop -->

<!-- BEGIN #content -->
<div id="content" class="app-content">

<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Fire Foresight</a>
      </li>
      <li class="breadcrumb-item">
        <a [routerLink]="['/fire-foresight','burn-list']">Planned List</a>
      </li>
      <li class="breadcrumb-item" *ngIf="selectedBurn">
        <a>{{selectedBurn.planName || ('Burn Plan #' + selectedBurn.id)}}</a>
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row gx-4 mt-4">
    <div class="col-12">

      <div *ngIf="loading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div *ngIf="!loading && plannedBurns.length === 0" class="alert alert-info">
        No planned burns scheduled at this time.
      </div>

      <!-- Burn List Map when no burn is selected -->
      <div *ngIf="!selectedBurn && !loading && plannedBurns.length > 0 && selectedBurnId == null" class="burn-list-map-container">
        <app-map #burnListMap></app-map>
      </div>

      <div *ngIf="selectedBurn" class="row">
        <div class="col-lg-6 col-md-12">
          <div class="card mb-4 bg-emphasis bg-opacity-25">
            <div class="card-header d-flex justify-content-between align-items-center">
              <!-- Tabs -->
              <ul class="nav nav-tabs card-header-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link"
                     [ngClass]="{'active': activeTab === 'details'}"
                     (click)="setActiveTab('details')"
                     style="cursor: pointer;">
                    {{selectedBurn.planName || 'Burn Plan #' + selectedBurn.id}}
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link"
                     [ngClass]="{'active': activeTab === 'journal'}"
                     (click)="setActiveTab('journal')"
                     style="cursor: pointer;">
                    Journal
                  </a>
                </li>
              </ul>

              <!-- Edit/Save/Cancel Buttons -->
              <div class="ms-2 d-flex gap-1">
                <button *ngIf="!isEditMode && activeTab === 'details' && isPlannedStatus()"
                        class="btn btn-sm btn-success"
                        (click)="startBurnPlan()"
                        [disabled]="loading"
                        title="Start Burn Plan">
                  <i class="bi bi-play-fill"></i> Start Burn
                </button>
                <button *ngIf="!isEditMode && activeTab === 'details' && isInProgressStatus() && areAllBurnCoupsCompleted()"
                        class="btn btn-sm btn-primary"
                        (click)="finishBurnPlan()"
                        [disabled]="loading"
                        title="Finish Burn Plan">
                  <i class="bi bi-check-circle-fill"></i> Finish Burn Plan
                </button>
                <button *ngIf="!isEditMode && activeTab === 'details'" class="btn btn-sm btn-outline-secondary" (click)="enableEditMode()" title="Edit">
                  <i class="bi bi-pencil"></i>
                </button>
                <div *ngIf="isEditMode" class="d-flex gap-1">
                  <button class="btn btn-sm btn-success" (click)="saveEdit()" [disabled]="loading" title="Save">
                    <i class="bi bi-check-lg"></i>
                  </button>
                  <button class="btn btn-sm btn-secondary" (click)="cancelEdit()" [disabled]="loading" title="Cancel">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Details Tab Content -->
            <div class="card-body" *ngIf="activeTab === 'details'">
              <div class="row">
                <div class="col-12">
                  <div class="mt-3">
                    <!-- Edit Mode: Show editable fields -->
                    <div *ngIf="isEditMode">
                      <div class="mb-3">
                        <label class="form-label"><strong>Plan Name:</strong></label>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="editingBurn.planName" placeholder="Burn Plan Name">
                      </div>
                      <div class="mb-3">
                        <label class="form-label"><strong>Expected Start:</strong></label>
                        <input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="editingBurn.expectedStartTime">
                      </div>
                      <div class="mb-3">
                        <label class="form-label"><strong>Expected End:</strong></label>
                        <input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="editingBurn.expectedEndTime">
                      </div>
                      <div class="mb-3">
                        <label class="form-label"><strong>Region:</strong></label>
                        <select class="form-select form-select-sm"
                                [(ngModel)]="editingBurn.burnListRegionId"
                                [disabled]="loading">
                          <option [value]="undefined">-- Select Region --</option>
                          <option *ngFor="let region of burnListRegions" [value]="region.id">
                            {{region.name}}
                          </option>
                        </select>
                      </div>
                      <div class="mb-3">
                        <label class="form-label"><strong>Status:</strong></label>
                        <select class="form-select form-select-sm"
                                [(ngModel)]="editingBurn.burnListStatusId"
                                [disabled]="loading">
                          <option [value]="undefined">-- Select Status --</option>
                          <option *ngFor="let status of burnListStatuses" [value]="status.id">
                            {{status.name}}
                          </option>
                        </select>
                      </div>
                      <hr>
                    </div>

                    <!-- View Mode: Show status as badge -->
                    <div *ngIf="!isEditMode" class="mb-3">
                      <strong>Status:</strong>
                      <span class="badge ms-2" [ngClass]="getStatusBadgeClass(selectedBurn.burnListStatusId)">
                        {{getBurnPlanStatusName(selectedBurn.burnListStatusId)}}
                      </span>
                    </div>

                    <div *ngIf="!isEditMode" class="mb-3">
                      <strong>Region:</strong>
                      <span class="ms-2">{{getBurnListRegionName(selectedBurn.burnListRegionId)}}</span>
                    </div>

                    <!-- Read-only fields (always shown) -->
                    <div class="mb-2"><strong>Planned Start:</strong> {{selectedBurn.expectedStartTime | date:'medium'}}</div>
                    <div class="mb-2" *ngIf="selectedBurn.expectedEndTime"><strong>Planned End:</strong> {{selectedBurn.expectedEndTime | date:'medium'}}</div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0">Burn Coups</h5>
                    <button class="btn btn-sm btn-primary" (click)="openAddCoupModal()" *ngIf="!isEditMode">
                      <i class="bi bi-plus-circle"></i> Add Coup
                    </button>
                  </div>
                  <div class="mt-3">
                    <div *ngIf="selectedBurn.burnCoups && selectedBurn.burnCoups.length > 0">
                      <div class="table-responsive">
                        <table class="table table-sm table-bordered" style="font-size: 0.875rem;">
                          <thead>
                            <tr>
                              <th style="width: 150px;">Coup ID</th>
                              <th class="text-center" style="width: 120px;">Shaded</th>
                              <th class="text-center" style="width: 120px;">Open</th>
                              <th class="text-center" style="width: 120px;">SDI</th>
                              <th class="text-center" style="width: 100px;">PM10</th>
                              <th class="text-center" style="width: 100px;">PM2.5</th>
                              <th class="text-center" style="width: 80px;">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let coup of getSortedBurnCoups()"
                                [ngClass]="{'text-muted bg-light': coup.disabled}"
                                [style.opacity]="coup.disabled ? '0.6' : '1'">
                              <td>
                                <div>
                                  <strong>{{coup.geoAsset.identifier.toUpperCase()}}</strong>
                                  <span *ngIf="coup.disabled" class="badge bg-secondary ms-2">
                                    <i class="bi bi-slash-circle"></i> Excluded
                                  </span>
                                </div>
                                <div *ngIf="getClosestAirQualityStationNameForBurnCoup(coup.id)" class="small text-muted" style="font-size: 0.75rem;">
                                  <i class="bi bi-wind"></i> {{getClosestAirQualityStationNameForBurnCoup(coup.id)}}
                                  <span *ngIf="getClosestAirQualityStationDistanceForBurnCoup(coup.id)"> ({{getClosestAirQualityStationDistanceForBurnCoup(coup.id)?.toFixed(1)}} km)</span>
                                </div>

                                <!-- Burn Action Buttons (only for In Progress burn plans) -->
                                <div *ngIf="isInProgressStatus() && !coup.disabled" class="mt-2">
                                  <!-- Show "Burn Started" button if not yet started -->
                                  <button *ngIf="!coup.burnStartedTime"
                                          class="btn btn-sm btn-success"
                                          (click)="startBurnCoup(coup)"
                                          [disabled]="loading"
                                          title="Mark burn as started">
                                    <i class="bi bi-play-circle"></i> Start Burn
                                  </button>

                                  <!-- Show "Burn Completed" button if started but not completed -->
                                  <button *ngIf="coup.burnStartedTime && !coup.burnCompletedTime"
                                          class="btn btn-sm btn-primary"
                                          (click)="finishBurnCoup(coup)"
                                          [disabled]="loading"
                                          title="Mark burn as completed">
                                    <i class="bi bi-check-circle"></i> Burn Completed
                                  </button>

                                  <!-- Show status if completed -->
                                  <span *ngIf="coup.burnCompletedTime" class="badge bg-success">
                                    <i class="bi bi-check-circle-fill"></i> Completed
                                  </span>
                                </div>
                              </td>
                              <td class="text-center align-middle"
                                  [ngClass]="getFuelMoistureShadedValue(coup.id) !== null ? getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) : ''">
                                <div *ngIf="getFuelMoistureShadedValue(coup.id) !== null"
                                     [ngClass]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) === 'bg-light' ? 'text-dark' : 'text-white'">
                                  <div class="fs-5 fw-bold">
                                    {{getFuelMoistureShadedValue(coup.id)}}%
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">
                                    {{formatAge(getFuelMoistureShadedAge(coup.id))}}
                                  </div>
                                </div>
                                <span *ngIf="getFuelMoistureShadedValue(coup.id) === null && !siteTwinsLoading"
                                      class="text-muted">
                                  N/A
                                </span>
                                <span *ngIf="siteTwinsLoading"
                                      class="spinner-border spinner-border-sm text-muted"
                                      role="status">
                                </span>
                              </td>
                              <td class="text-center align-middle"
                                  [ngClass]="getFuelMoistureUnshadedValue(coup.id) !== null ? getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) : ''">
                                <div *ngIf="getFuelMoistureUnshadedValue(coup.id) !== null"
                                     [ngClass]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) === 'bg-light' ? 'text-dark' : 'text-white'">
                                  <div class="fs-5 fw-bold">
                                    {{getFuelMoistureUnshadedValue(coup.id)}}%
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">
                                    {{formatAge(getFuelMoistureUnshadedAge(coup.id))}}
                                  </div>
                                </div>
                                <span *ngIf="getFuelMoistureUnshadedValue(coup.id) === null && !siteTwinsLoading"
                                      class="text-muted">
                                  N/A
                                </span>
                                <span *ngIf="siteTwinsLoading"
                                      class="spinner-border spinner-border-sm text-muted"
                                      role="status">
                                </span>
                              </td>
                              <td class="text-center align-middle"
                                  [ngClass]="getSDIValue(coup.id) !== null ? getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) : ''">
                                <div *ngIf="getSDIValue(coup.id) !== null"
                                     [ngClass]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) === 'bg-light' ? 'text-dark' : 'text-white'">
                                  <div class="fs-5 fw-bold">
                                    {{getSDIValue(coup.id)}}
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">
                                    {{formatAge(getSDIAge(coup.id))}}
                                  </div>
                                </div>
                                <span *ngIf="getSDIValue(coup.id) === null && !siteTwinsLoading"
                                      class="text-muted">
                                  
                                </span>
                                <span *ngIf="siteTwinsLoading"
                                      class="spinner-border spinner-border-sm text-muted"
                                      role="status">
                                </span>
                              </td>
                              <td class="text-center align-middle"
                                  [ngClass]="getPM10ColorForBurnCoup(coup.id)">
                                <div *ngIf="getPM10ValueForBurnCoup(coup.id) !== null"
                                     class="text-white">
                                  <div class="fs-5 fw-bold">
                                    {{getPM10ValueForBurnCoup(coup.id)?.toFixed(1)}}
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">
                                    µg/m³
                                  </div>
                                </div>
                                <span *ngIf="getPM10ValueForBurnCoup(coup.id) === null && !airQualitySitesLoading"
                                      class="text-muted">
                                  N/A
                                </span>
                                <span *ngIf="airQualitySitesLoading"
                                      class="spinner-border spinner-border-sm text-muted"
                                      role="status">
                                </span>
                              </td>
                              <td class="text-center align-middle"
                                  [ngClass]="getPM25ColorForBurnCoup(coup.id)">
                                <div *ngIf="getPM25ValueForBurnCoup(coup.id) !== null"
                                     class="text-white">
                                  <div class="fs-5 fw-bold">
                                    {{getPM25ValueForBurnCoup(coup.id)?.toFixed(1)}}
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">
                                    µg/m³
                                  </div>
                                </div>
                                <span *ngIf="getPM25ValueForBurnCoup(coup.id) === null && !airQualitySitesLoading"
                                      class="text-muted">
                                  N/A
                                </span>
                                <span *ngIf="airQualitySitesLoading"
                                      class="spinner-border spinner-border-sm text-muted"
                                      role="status">
                                </span>
                              </td>
                              <td class="text-center align-middle">
                                <div class="btn-group" role="group">
                                  <button class="btn btn-xs btn-outline-theme mr-2" title="Quick View Dashboard" (click)="openDashboard(coup, fuelMoistureSiteType);dashboard.show()" *ngIf="fuelMoistureSiteType && fuelMoistureSiteType.dashboards && fuelMoistureSiteType.dashboards.length > 0">
                                    <i class="bi bi-speedometer2"></i>
                                  </button>
                                  <div class="btn-group" dropdown placement="bottom left">
                                    <button class="btn btn-xs btn-outline-secondary dropdown-toggle"
                                            dropdownToggle
                                            type="button"
                                            title="Coup actions">
                                      <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-end" role="menu">
                                      <li role="menuitem">
                                        <a class="dropdown-item" (click)="openMoveCoupModal(coup)">
                                          <i class="bi bi-arrow-right me-2"></i>Move Coup
                                        </a>
                                      </li>
                                      <li role="menuitem">
                                        <a class="dropdown-item" (click)="removeCoupFromBurnPlanByCoup(coup)">
                                          <i class="bi bi-x-circle me-2"></i>Remove Coup
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <small class="text-muted">
                        <i class="bi bi-info-circle"></i>
                        Air quality values (PM10, PM2.5) are from the closest EPA monitoring station to each burn coup
                      </small>
                    </div>
                    <div *ngIf="!selectedBurn.burnCoups || selectedBurn.burnCoups.length === 0" class="text-muted">
                      No burn coups assigned to this plan.
                    </div>

                  </div>
                </div>
              </div>

              <!-- Weather Station Section -->
              <div class="row mt-4" *ngIf="!isEditMode">
                <div class="col-12">
                  <h5 class="mb-3">Weather Station</h5>
                  <div *ngIf="weatherStationSitesLoading" class="text-center p-3">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading weather data...</span>
                    </div>
                  </div>

                  <div *ngIf="!weatherStationSitesLoading && !getNearestWeatherStation(selectedBurn)" class="text-muted">
                    No weather station data available.
                  </div>

                  <div *ngIf="!weatherStationSitesLoading && getNearestWeatherStation(selectedBurn)">
                    <ng-container *ngIf="getNearestWeatherStation(selectedBurn) as station">
                      <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                          <thead>
                            <tr>
                              <th>Station</th>
                              <th class="text-center" style="width: 120px;">Temperature</th>
                              <th class="text-center" style="width: 120px;">Humidity</th>
                              <th class="text-center" style="width: 120px;">Wind Speed</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>{{station.siteDescription || station.siteName || 'Unknown Station'}}</strong>
                                <div class="small text-muted">{{station.distance.toFixed(1)}} km away</div>
                              </td>
                              <td class="text-center align-middle">
                                <div *ngIf="getTemperatureValue(station) !== null">
                                  <div class="fw-bold">{{getTemperatureValue(station)?.toFixed(1)}} °C</div>
                                  <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                                </div>
                                <small *ngIf="getTemperatureValue(station) === null" class="text-muted">N/A</small>
                              </td>
                              <td class="text-center align-middle">
                                <div *ngIf="getHumidityValue(station) !== null">
                                  <div class="fw-bold">{{getHumidityValue(station)?.toFixed(0)}}%</div>
                                  <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                                </div>
                                <small *ngIf="getHumidityValue(station) === null" class="text-muted">N/A</small>
                              </td>
                              <td class="text-center align-middle">
                                <div *ngIf="getWindSpeedValue(station) !== null">
                                  <div class="fw-bold">
                                    {{getWindSpeedValue(station)?.toFixed(1)}} km/h
                                    <span *ngIf="getWindDirectionValue(station) !== null" class="small text-muted ms-1">
                                      ({{getWindDirectionValue(station)?.toFixed(0)}}°)
                                    </span>
                                  </div>
                                  <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                                </div>
                                <small *ngIf="getWindSpeedValue(station) === null" class="text-muted">N/A</small>
                              </td>
                              <td class="text-center align-middle">
                                <div class="btn-group" role="group">
                                  <button class="btn btn-xs btn-outline-theme mr-2" title="Quick View Dashboard" (click)="openDashboard(station, weatherStationSiteType);dashboard.show()" *ngIf="fuelMoistureSiteType && fuelMoistureSiteType.dashboards && fuelMoistureSiteType.dashboards.length > 0">
                                    <i class="bi bi-speedometer2"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <small class="text-muted">
                        <i class="bi bi-info-circle"></i>
                        Showing nearest available weather station
                      </small>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Journal Tab Content -->
            <div class="card-body journal-container" *ngIf="activeTab === 'journal'">
              <div class="chat-messages mb-3" style="max-height: 500px; overflow-y: auto;">
                <div *ngIf="!selectedBurn.burnListComments || selectedBurn.burnListComments.length === 0" class="text-center text-muted py-5">
                  No comments yet. Be the first to add a comment!
                </div>

                <div *ngFor="let comment of selectedBurn.burnListComments"
                     class="mb-3"
                     [ngClass]="{'text-end': isCurrentUserComment(comment)}">
                  <div class="comment-bubble d-inline-block"
                       [ngClass]="{
                         'bg-primary text-white': isCurrentUserComment(comment),
                         'bg-light': !isCurrentUserComment(comment)
                       }"
                       style="max-width: 70%; padding: 10px 15px; border-radius: 15px;">
                    <div class="small mb-1" [ngClass]="{'text-white-50': isCurrentUserComment(comment), 'text-muted': !isCurrentUserComment(comment)}">
                      <strong>{{comment.userDisplayName}}</strong>
                      <span class="ms-2">{{comment.commentTimestamp | relativeDate}}</span>
                    </div>
                    <div>{{comment.comment}}</div>
                  </div>
                </div>
              </div>

              <!-- Add Comment Input -->
              <div class="mt-3">
                <div class="input-group">
                  <textarea class="form-control"
                            [(ngModel)]="newComment"
                            placeholder="Type your comment..."
                            rows="2"
                            [disabled]="addingComment"
                            (keydown)="onCommentKeyDown($event)"></textarea>
                  <button class="btn btn-primary"
                          (click)="addComment()"
                          [disabled]="!newComment.trim() || addingComment">
                    <span *ngIf="!addingComment">
                      <i class="bi bi-send"></i> Send
                    </span>
                    <span *ngIf="addingComment" class="spinner-border spinner-border-sm" role="status"></span>
                  </button>
                </div>
                <small class="text-muted">Press Ctrl+Enter to send</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="card mb-4 bg-emphasis bg-opacity-25">
            <div class="card-header">
              <div class="fw-bold">
                Burn Coup Map
                <span class="badge bg-secondary ms-2">Zoom: {{currentZoomLevel | number:'1.0-0'}}</span>
              </div>
              <small class="text-inverse text-opacity-50">
                <span style="color: #3388ff;">■</span> Available Coups
                <span class="ms-2" style="color: #999999;">■</span> Disabled Coups
                <span class="ms-2" style="color: #28a745;">■</span> Safe to burn
                <span class="ms-2" style="color: #ffc107;">■</span> Warning
                <span class="ms-2" style="color: #dc3545;">■</span> Unsafe
              </small>
                <button class="btn btn-outline-primary btn-sm float-end"
                        style="position: absolute; top: 10px; right: 10px; z-index: 2;"
                        (click)="loadVisibleCoups()"
                        [disabled]="!isLoadCoupsButtonEnabled()"
                        [title]="!isLoadCoupsButtonEnabled() ? 'Zoom in closer to load coups (zoom level ' + (minZoomLevelForGeoAssets - 2) + ' or higher)' : 'Load coups visible in current map view'">
                  <i class="fa fa-eye"></i> Load Visible Coups
                </button>
            </div>
            <div class="card-body p-0" style="position: relative;">
              <app-map #coupMap [mapheight]="500"></app-map>
              <div *ngIf="coupsLoading" class="text-center p-5" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.8); display: flex; align-items: center; justify-content: center; z-index: 1000;">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading coups...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

</div>

<!-- Create New Burn Modal -->
<div class="modal fade" bsModal #createBurnModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="createBurnModalLabel">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="createBurnModalLabel">Create New Burn List</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="createBurnModal.hide()" [disabled]="savingBurn"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label for="burnName" class="form-label">Burn List Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="burnName"
              [(ngModel)]="newBurn.planName"
              name="planName"
              placeholder="Enter burn plan name"
              [disabled]="savingBurn"
              required>
          </div>
          <div class="mb-3">
            <label for="burnRegion" class="form-label">Region <span class="text-danger">*</span></label>
            <select
              class="form-select"
              id="burnRegion"
              [(ngModel)]="newBurn.burnListRegionId"
              name="burnListRegionId"
              [disabled]="savingBurn"
              required>
              <option [ngValue]="null">Select a region...</option>
              <option *ngFor="let region of burnListRegions" [ngValue]="region.id">
                {{region.name}}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="burnType" class="form-label">Burn Type <span class="text-danger">*</span></label>
            <select
              class="form-select"
              id="burnType"
              [(ngModel)]="newBurn.burnListTypeId"
              name="burnListTypeId"
              [disabled]="savingBurn"
              required>
              <option [ngValue]="null">Select a burn type...</option>
              <option *ngFor="let type of burnListTypes" [ngValue]="type.id">
                {{type.name}}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="startDate" class="form-label">Expected Start Date & Time <span class="text-danger">*</span></label>
            <input
              type="datetime-local"
              class="form-control"
              id="startDate"
              [(ngModel)]="newBurn.expectedStartTime"
              name="expectedStartTime"
              [disabled]="savingBurn"
              required>
          </div>
          <div class="mb-3">
            <label for="endDate" class="form-label">Expected End Date & Time</label>
            <input
              type="datetime-local"
              class="form-control"
              id="endDate"
              [(ngModel)]="newBurn.expectedEndTime"
              name="expectedEndTime"
              [disabled]="savingBurn">
            <small class="form-text text-muted">Optional - leave empty if not yet determined</small>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="createBurnModal.hide()" [disabled]="savingBurn">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createNewBurn()" [disabled]="savingBurn || !newBurn.planName || !newBurn.expectedStartTime || !newBurn.burnListRegionId || !newBurn.burnListTypeId">
          <span *ngIf="!savingBurn"><i class="bi bi-check-circle me-1"></i> Create Burn</span>
          <span *ngIf="savingBurn">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Creating...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Coup Search Modal -->
<div class="modal fade" bsModal #addCoupModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="addCoupModalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addCoupModalLabel">Search and Add Coup</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addCoupModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="coupSearch" class="form-label">Search for Coup</label>
          <input
            type="text"
            class="form-control"
            id="coupSearch"
            [(ngModel)]="coupSearchQuery"
            (ngModelChange)="onCoupSearchQueryChange()"
            placeholder="Enter coup identifier or name..."
            autofocus>
          <small class="form-text text-muted">Type to search for coups by identifier or name</small>
        </div>

        <div *ngIf="coupSearching" class="text-center p-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Searching...</span>
          </div>
        </div>

        <div *ngIf="!coupSearching && coupSearchResults.length === 0 && coupSearchQuery.trim().length > 0" class="alert alert-info">
          No coups found matching your search.
        </div>

        <div *ngIf="!coupSearching && coupSearchResults.length > 0" class="list-group">
          <div *ngFor="let coup of coupSearchResults"
               class="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
               [ngClass]="{'list-group-item-secondary': isCoupAlreadyInBurnPlan(coup.id)}"
               [style.cursor]="isCoupAlreadyInBurnPlan(coup.id) ? 'not-allowed' : 'pointer'"
               (click)="!isCoupAlreadyInBurnPlan(coup.id) && selectCoupFromSearch(coup)">
            <div class="flex-grow-1">
              <div class="fw-bold">{{coup.identifier || 'Coup #' + coup.id}}</div>
              <div class="small text-muted" *ngIf="coup.name">{{coup.name}}</div>
              <div class="small text-muted" *ngIf="coup.description">{{coup.description}}</div>
              <span *ngIf="isCoupAlreadyInBurnPlan(coup.id)" class="badge bg-secondary mt-1">
                <i class="bi bi-check-circle"></i> Already in Burn Plan
              </span>
            </div>
            <div *ngIf="!isCoupAlreadyInBurnPlan(coup.id)">
              <i class="bi bi-plus-circle text-primary" style="font-size: 1.5rem;"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="addCoupModal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Move Burn Coup Modal -->
<div class="modal fade" bsModal #moveCoupModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="moveCoupModalLabel">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moveCoupModalLabel">
          Move Burn Coup: {{coupToMove?.geoAsset?.identifier?.toUpperCase()}}
        </h5>
        <button type="button" class="btn-close" (click)="cancelMoveCoup()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          <p class="text-muted">
            Select a destination burn list or create a new one. The target burn list must be in the same region
            ({{getBurnListRegionName(selectedBurn?.burnListRegionId)}}) and of type "Burn Day".
          </p>
        </div>

        <!-- Option selector -->
        <div class="mb-3">
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="moveOption"
                   id="moveToExisting"
                   [checked]="!createNewTargetList"
                   (change)="selectExistingList()">
            <label class="form-check-label fw-bold" for="moveToExisting">
              Move to Existing Burn List
            </label>
          </div>
        </div>

        <!-- Existing burn lists -->
        <div *ngIf="!createNewTargetList" class="mb-4 ms-4">
          <div *ngIf="availableTargetBurnLists.length === 0" class="alert alert-info">
            <i class="bi bi-info-circle"></i> No eligible burn lists found.
            Create a new burn list below.
          </div>
          <div *ngIf="availableTargetBurnLists.length > 0" class="list-group">
            <div *ngFor="let burnList of availableTargetBurnLists"
                 class="list-group-item list-group-item-action"
                 [class.active]="targetBurnListId === burnList.id"
                 style="cursor: pointer;"
                 (click)="targetBurnListId = burnList.id">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h6 class="mb-1">{{burnList.planName || 'Burn List #' + burnList.id}}</h6>
                  <small>
                    <i class="bi bi-calendar"></i>
                    {{burnList.expectedStartTime | date:'short'}}
                  </small>
                  <span class="badge bg-secondary ms-2">{{burnList.burnCoups?.length || 0}} coups</span>
                </div>
                <div *ngIf="targetBurnListId === burnList.id">
                  <i class="bi bi-check-circle-fill text-success" style="font-size: 1.5rem;"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Create new burn list option -->
        <div class="mb-3">
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="moveOption"
                   id="moveToNew"
                   [checked]="createNewTargetList"
                   (change)="selectCreateNewList()">
            <label class="form-check-label fw-bold" for="moveToNew">
              Create New Burn List
            </label>
          </div>
        </div>

        <!-- New burn list form -->
        <div *ngIf="createNewTargetList" class="ms-4">
          <div class="mb-3">
            <label for="newBurnListName" class="form-label">
              Burn List Name <span class="text-danger">*</span>
            </label>
            <input type="text"
                   class="form-control"
                   id="newBurnListName"
                   [(ngModel)]="newTargetBurnList.planName"
                   placeholder="Enter burn list name"
                   required>
          </div>
          <div class="mb-3">
            <label for="newBurnListStartDate" class="form-label">
              Start Date <span class="text-danger">*</span>
            </label>
            <input type="datetime-local"
                   class="form-control"
                   id="newBurnListStartDate"
                   [(ngModel)]="newTargetBurnList.expectedStartTime"
                   required>
          </div>
          <div class="alert alert-info">
            <i class="bi bi-info-circle"></i>
            <strong>Region:</strong> {{getBurnListRegionName(selectedBurn?.burnListRegionId)}}<br>
            <strong>Type:</strong> Burn Day
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-white" (click)="cancelMoveCoup()" [disabled]="movingCoup">
          Cancel
        </button>
        <button type="button"
                class="btn btn-primary"
                (click)="moveBurnCoup()"
                [disabled]="movingCoup || (!createNewTargetList && !targetBurnListId)">
          <span *ngIf="movingCoup" class="spinner-border spinner-border-sm me-2" role="status"></span>
          <i *ngIf="!movingCoup" class="bi bi-arrow-right me-1"></i>
          Move Burn Coup
        </button>
      </div>
    </div>
  </div>
</div>




<!-- Show Dashboards Modal -->
<div class="modal modal-cover fade" bsModal #dashboard="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog dashboard-modal">
        <div class="modal-content">
            <button type="button" class="btn-close position-fixed top-0 end-0 m-3" style="z-index: 9999;" aria-label="Close" (click)="dashboard.hide()"></button>
            <div class="modal-body">
                <app-dashboard #dashboardViewer [delayLoad]="true" [showEditor]="false"></app-dashboard>
            </div>
        </div>
    </div>
</div>
